import { Col, Row } from "@/utils/bootstrap";
import SvgRadioCheckbox from "./SvgRadioCheckbox";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  is_multi_select: boolean;
  label: React.ReactNode;
  disabled?: boolean;
  optionRef?: any;
  value?: any;
  disabledAndChecked?: boolean;
  /** Disabled overall, yet still selectable (out-of-stock restock reminder flow). */
  allowSelectOutOfStock?: boolean;
  /** Renders the label in a muted tone — used for sold-out options. */
  muted?: boolean;
}

const BaseOption: React.FC<Props> = ({
  selected,
  toggleOption,
  is_multi_select,
  label,
  disabled = false,
  optionRef,
  value,
  disabledAndChecked,
  allowSelectOutOfStock,
  muted,
}) => {
  const selectable = !disabled || !!allowSelectOutOfStock;
  return (
    <Row
      className="m-0"
      onClick={selected || selectable ? toggleOption : undefined}
      style={{
        gap: 6,
        cursor: !selected && disabled ? "not-allowed" : "pointer",
      }}
    >
      <Col className="p-0 col-auto  mt-1">
        <input
          type="radio"
          className="radioButton-input"
          value={value}
          ref={optionRef}
          checked={selected}
          disabled={!selected && !selectable}
          onChange={selected || selectable ? toggleOption : undefined}
        />
        <SvgRadioCheckbox
          is_multi_select={is_multi_select}
          checked={selected}
          checkedAndDisabled={disabledAndChecked}
        />
      </Col>
      <Col className={`p-0 text-wrap ${muted ? "option-label-muted" : ""}`}>
        {label}
      </Col>
    </Row>
  );
};

export default BaseOption;
